import { EnvironmentConfigType } from '@smx-ui-relay/relay-types';

import { API } from '../common';

export const EnvironmentConfig: EnvironmentConfigType = {
    devToken: API.GRAPHQL_TOKEN,
    authUrl: '',
    availableServicesUrl: 'https://4f4ze5lxbh.execute-api.us-west-2.amazonaws.com/prod/get-available-service',
    loadToken: () => Promise.resolve(null),
    saveToken: () => Promise.resolve(),
};
